module.exports = __webpack_public_path__ + "static/media/linux.9bb3c026.svg";